import { RedirectType } from '@/models/redirects.model';

export const getRedirectTypeOptions = () => [
  {
    value: RedirectType.TEMPORARY,
    label: '302',
  },
  {
    value: RedirectType.PERMANENT,
    label: '301',
  },
];
